export const WORK_PERMIT_OPTIONS = [
  { value: "hsm", description: "Highly Skilled Migrant (HSM) Visa" },
  { value: "eu_blue_card", description: "EU Blue Card" },
  { value: "permanent_resident", description: "Permanent Resident" },
  { value: "other", description: "Other" },
] as const;
